import Response from './response'
import httpInterceptorManager from './interceptor'

export default function (options) {
	if(!options.url || !options.method) {
		throw new Error('some required options are not provided');
	}

	let xhr = new XMLHttpRequest();
	const promise = new Promise((resolve, reject) => {

		options = httpInterceptorManager.runInterceptorsMethod('request', options);

		let success = (event) => {
			let response = new Response(options, xhr);
			if(xhr.status >= 200 && xhr.status < 300) {
				response = httpInterceptorManager.runInterceptorsMethod('response', response);
				resolve(response);
			}else {
				response = httpInterceptorManager.runInterceptorsMethod('responseError', response);
				reject(response);
			}
		};

		let error = (event) => {
			options = httpInterceptorManager.runInterceptorsMethod('requestError', options);
			options.event = event;
			reject(new Response(options, xhr))
		};

		xhr.open(options.method, options.url, true);

		if (options.responseType) {
			xhr.responseType = options.responseType;
		}

		if(options.headers) {
			for(let headerName in options.headers) {
				let headerValue = options.headers[headerName];
				xhr.setRequestHeader(headerName, headerValue);
			}
		}

		xhr.timeout = options.timeout || 0
		xhr.onload = success;
		xhr.onabort = error;
		xhr.onerror = error;
		xhr.ontimeout = error;
		xhr.send(options.data);

	});

	console.debug(promise);
	promise.cancel = () => {
		xhr.abort();
	}

	return promise;
}



// WEBPACK FOOTER //
// ../common/utils/http/xhr.js